<div class="emptySearch">
  <div class="emptySearch--text">
    {{ 'casNoResults' | translate }}
  </div>
  <div class="emptySearch--games">
    <casino-category-slider-new [controls]="isDesktop" [category]="emptyCategory" (turnPlay)="playGame($event)"> </casino-category-slider-new>
  </div>
</div>
